<template>
    <div class="afu-pb-64 afu-px-5 md:afu-px-0">
        <div class="af-dashboard-container afu-flex afu-w-full afu-max-w-screen-xl afu-ml-auto afu-mr-auto">
            <div class="af-dashboard-sidebar afu-hidden md:afu-block afu-mr-10">
                <Menu />
            </div>

            <div class="af-dashboard-content afu-relative afu-flex-1 afu-max-w-full">
                <RouterView />
            </div>
        </div>
    </div>
</template>

<script>
    import Menu from '@/apps/dashboard/001/components/Menu';

    export default {
        name: 'Default',

        components: {
            Menu,
        },

        data() {
            return {};
        },

        methods: {
        },
    };
</script>
